import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { FRAGMENT_IMAGE } from "../../../Components/Property/LazyImageGallery/LazyImageGallery.hook";
import { FRAGMENT_PROPERTY_MODAL_VIDEO } from "./PropertyModalVideo/PropertyModalVideo.hook";
import { FRAGMENT_PROPERTY_MODAL_FLOOR_PLANS } from "./PropertyModalFloorPlans/PropertyModalFloorPlans.hook";
import { FRAGMENT_MAP } from "../../../Components/Property/PropertyMap/hook";

export const FRAGMENT_PROPERTY_MODAL = new FragmentDefiner(
	"Property",
	`
    id
    img
    image_count
		project {
			id
			files {
				id
			}
		}
`
).uses(
	FRAGMENT_IMAGE,
	FRAGMENT_PROPERTY_MODAL_VIDEO,
	FRAGMENT_PROPERTY_MODAL_FLOOR_PLANS,
	FRAGMENT_MAP
);

export function usePropertyModal({ id, images }) {
	const { loading, data, error } = useReadFragment(FRAGMENT_PROPERTY_MODAL, id);

	return {
		loading,
		data,
		error,
		constructionImages: images.some(e => e.tag == "construction_advances"),
	};
}
